import { Injectable } from '@angular/core';

import { AsnDarkmodeService } from './darkmode.service';

@Injectable({
    providedIn: 'root'
})
export class ApDarkmodeService extends AsnDarkmodeService {
    // Angular wrapper - inherits all methods from core
}
